import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {
  DEFAULT_INTERFACE_LOCALE,
  normalizeInterfaceLocale,
  readStoredInterfaceLocale,
  storeInterfaceLocale,
  translateInterface
} from '../lib/i18n/interfaceLanguage';

const LanguageContext = createContext(null);

export function LanguageProvider({children}) {
  const [locale, setLocale] = useState(() => readStoredInterfaceLocale());

  const setLanguage = useCallback((nextLocale) => {
    const normalized = storeInterfaceLocale(nextLocale);
    setLocale(normalized);
    return normalized;
  }, []);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const t = useCallback(
    (key, values) => translateInterface(locale, key, values),
    [locale]
  );

  const value = useMemo(
    () => ({locale, setLanguage, t}),
    [locale, setLanguage, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const value = useContext(LanguageContext);

  if (!value) {
    return {
      locale: DEFAULT_INTERFACE_LOCALE,
      setLanguage: () => DEFAULT_INTERFACE_LOCALE,
      t: (key) => key
    };
  }

  return value;
}

export function localeFromUser(user) {
  return normalizeInterfaceLocale(user?.user_metadata?.interface_locale);
}
